<template>
<!-- :class="'bg-'+field" -->
    <div class="row mt-3 mb-3 py-3 headerPanel align-items-center bg-white" >
        <div class="col-sm-12">
            <div class="row align-items-center justify-content-between">
                <div v-if="field==='contact'" class="col-12 col-md-5">
                    <div class="float-left">
                        <h1 class="f-14 m-0" :title="data.n+' '+data.sn">{{data.n}} {{data.sn}}</h1>
                        <span class="f-12" v-if="data.jobTitle!=null">{{data.jobTitle}}</span>
                        <div v-if="contactOrg!=undefined && contactOrg.name!=null" class="f-12 mt-2 cursor-pointer light-darkGray-color" @click="organizationCard(contactOrg._id.$oid)">{{filterName(contactOrg.name)}}</div>
                    </div>
                </div>
                <div v-if="field==='organization'" class="col-12 col-sm-5">
                    <h1 class="f-13 m-0" :title="data.name">{{filterName(data.name)}}</h1>
                </div>
                <div class="col-12 col-md-7 mt-3 mt-md-0">
                    <div class="float-md-right">
                        <div class="float-md-left f-12 d-flex align-items-center justify-content-between">
                            <!-- <div v-if="field==='contact'" class="bg-new-light pr-0 pt-1 pb-1 pl-1">{{$ml.get('HOLDER')}} - <span class="bg-new-gray p-1">{{ownerFullName}}</span></div> -->
                              <div v-if="field==='organization'" class="bg-new-light pr-0 pl-1 border border-radius-4 w-100 d-flex align-items-center" style="height:28px;">
                            <span class="holderTitle py-1 px-2">{{$ml.get('HOLDER')}} </span>
                            <span v-if="$can('can_change_owner_of_items')" class="border-left px-2 p-1 cursor-pointer d-flex justify-content-center align-items-center bg-white hover-bg-primary" data-toggle="dropdown" id="userList" aria-haspopup="true" aria-expanded="false">{{ownerFullName}}<i class="fa fa-angle-down f-16 ml-1"></i></span>
                           <span v-else class="bg-white hover-bg-primary p-1 px-2 d-flex align-items-center justify-content-center " id="userList" aria-haspopup="true" aria-expanded="false">{{ownerFullName}}</span>
                           
                            <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="userList">
                                 <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                    <ul class="new-dropdown border-radius-0 p-0">
                                        <li v-if="usersForFilter.length==0">{{$ml.get('NO_USER_FOUND')}}</li>
                                          <li class="p-0" v-for="(u,index) in usersForFilter" :key="index">
                                             <label class="w-100 custom-checkbox">
                                                 <input v-if="organization.hasOwnProperty('cuid')" type="radio" name="filter" :checked="u._id.$oid===organization.cuid.$oid" @change="changeHolder($event)" :value="u['_id']['$oid']"> 
                                                 <span class="label-text f-14">{{u.name}} {{u.surName}}</span>
                                             </label>
                                          </li>
                                     </ul> 
                            </div>
                            </div>

                            <div v-if="field==='contact'" class="bg-new-light pr-0 pl-1 border border-radius-4 w-100 d-flex align-items-center" style="height:28px;">
                            <span class="holderTitle py-1 px-2">{{$ml.get('HOLDER')}} </span>
                            <span v-if="$can('can_change_owner_of_items')" class="border-left px-2 p-1 cursor-pointer d-flex justify-content-center align-items-center bg-white hover-bg-primary" data-toggle="dropdown" id="userList" aria-haspopup="true" aria-expanded="false">{{ownerFullName}}<i class="fa fa-angle-down f-16 ml-1"></i></span>
                           <span v-else class="bg-white hover-bg-primary p-1 px-2 d-flex align-items-center justify-content-center" id="userList" aria-haspopup="true" aria-expanded="false">{{ownerFullName}}</span>
                           
                            <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0" aria-labelledby="userList">
                                 <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                    <ul class="new-dropdown border-radius-0 p-0">
                                        <li v-if="usersForFilter.length==0">{{$ml.get('NO_USER_FOUND')}}</li>
                                          <li class="p-0" v-for="(u,index) in usersForFilter" :key="index">
                                             <label class="w-100 custom-checkbox">
                                                 <input type="radio" name="filter"  @change="changeHolder($event)" :value="u['_id']['$oid']" > 
                                                 <span class="label-text f-14">{{u.name}} {{u.surName}}</span>
                                             </label>
                                          </li>
                                     </ul> 
                            </div>
                            </div>
                        
                            <div class="d-flex">
                                <div class="ml-2 crm-detail-icon-btn ml-2 d-flex justify-content-center align-items-center">
                                <i class="far fa-plus-square crm-icon-color f-16 cursor-pointer " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu dropdown-menu-right p-0 multiChoose">
                                    <ul class="new-dropdown p-0">
                                        <li data-toggle="modal" data-target="#addDeal">{{$ml.get('ADD_OPORTUNITY')}}</li>
                                        <li data-toggle="modal" data-target="#addActivity">{{$ml.get('ADD_ACTIVITY')}}</li>
                                        <li data-toggle="modal" data-target="#noteAdd">{{$ml.get('ADD_NOTE')}}</li>
                                    </ul>
                                </div>
                                </div>
                                <div class="ml-2 crm-detail-icon-btn ml-2 d-flex justify-content-center align-items-center">
                                    <i class="fas fa-edit crm-icon-color f-16 cursor-pointer " v-if="field=='contact'" @click="$emit('editContact')"></i>
                                    <i class="fas fa-edit crm-icon-color f-16 cursor-pointer " v-if="field=='organization'" @click="$emit('editOrg')"></i>
                                </div>
                                <div class="ml-2 crm-detail-icon-btn ml-2 d-flex justify-content-center align-items-center">
                                    <i class="far fa-trash-alt color-gray f-16 cursor-pointer" data-toggle="modal" data-target="#delete"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Delete -->
        <div class="modal fade" id="delete" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-family-bold f-18 f-w-normal" id="exampleModalLongTitle">{{$ml.get('DO_YOU_DELETE')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body font-family-bold f-14 f-w-normal">
                    {{field=='organization'?$ml.get('ARE_YOU_DELETE_ORGANIZATION'):$ml.get('ARE_YOU_DELETE_PROFILE')}}
                </div>
                <div class="modal-footer btnStyle">
                    <button type="button" class="btn btn-secondary font-family-bold f-14 f-w-normal h-32" data-dismiss="modal">{{$ml.get('NO')}}</button>
                    <button type="button" class="btn btn-primary font-family-bold f-14 f-w-normal h-32"  @click="remove(data._id.$oid)">{{$ml.get('YES')}}!</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapState,mapActions,mapGetters} from 'vuex'
export default {
  name: 'ContactCard',
  data () {
    return {
        userSearch:"",
        deal:[],
        ownerName:"",
        ownerSurName:"",
    }
  },
  props:["user","users","field","permissions","data","contactOrg"],
  computed:{
    ...mapState([
        'baseUrl'
    ]),
    ...mapGetters(['organization']),
//      ...mapGetters({
//             organizationFromStore: 'organization',
//             contactFromStore: 'contact'
//         }),

//     organization: {
//     get(){
//       return this.organizationFromStore
     
//     },
//     set(newOrganization){
//       return newOrganization
//     } 
//  },
//    contact: {
//     get(){
//       return this.contactFromStore
     
//     },
//     set(newContact){
//       return newContact
//     } 
//  },
    ownerFullName:function(){
        if(this.field==="contact"){
             if(this.data.cuid!==undefined)
            {
                if(this.data.cuid.hasOwnProperty('$oid'))
                {
                    var owId = this.data.cuid.$oid
                }
            }
            
           
         this.ownerName = this.user.name
         this.ownerSurName = this.user.surName
          for(var u in this.users)
            {
                if(this.users[u]._id.$oid==this.data.cuid.$oid){
                    this.ownerName=this.users[u].name
                    this.ownerSurName=this.users[u].surName
                }
            }
             return (this.ownerName + " " + this.ownerSurName)
            
        }
          else if(this.field==='organization')
        {
            if(this.organization.hasOwnProperty('cuid')){

                if(this.data.cuid!==undefined)
                {
                    if(this.data.cuid.hasOwnProperty('$oid'))
                    {
                        var owId = this.data.cuid.$oid
                    }
                }
                console.log("organizaiton");
                console.log(this.organization);
            this.ownerName = this.user.name
            this.ownerSurName = this.user.surName
            
            for(var u in this.users)
                {
                    if(this.users[u]._id.$oid==this.organization.cuid.$oid){
                        this.ownerName=this.users[u].name
                        this.ownerSurName=this.users[u].surName
                    }
                }
                return (this.ownerName + " " + this.ownerSurName)
            }
            return ""
        }
        
    },
        usersForFilter(){
        // function to compare names
        function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
        }
        
        return this.users.filter(user => {
            return user.name.toLowerCase().includes(this.userSearch.toLowerCase()) || user.surName.toLowerCase().includes(this.userSearch.toLowerCase())
        }).sort(compare)
    },
    
},
  methods:{
    remove(id){
        let obj = {}
        let url = ""
        if(this.field==="contact"){
            url="/deleteContact"
        }else if(this.field==='organization'){
            url="/deleteOrganization"
        }
        obj["objId"]=id
        this.delete(url,obj)
    },
    
    delete(urlx,obj){
        if(this.permissionSet()){
            return false
        }
         
        axios({
            method:'POST',
            url:urlx,
            baseURL: this.baseUrl,
            data: obj,
            withCredentials:true
        }).then((res)=>{
                return res
        }).then((res)=>{
            if(!res.data.status){
                this.$router.push('/logout')
            }
            if(res.data.status.code==0){
                $("#delete").modal("hide")
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: this.$ml.get('DELETED'), 
                    text: res.data.status.desc 
                })
                if(this.field==="contact"){
                    this.$router.push('/contacts')
                }else if(this.field==="organization"){
                    this.$router.push('/organizations')
                }
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    permissionSet(){
        if(this.$route.path==="/contactCard/"+this.$route.params.contactId){
            if(!this.permissions.includes("can_delete_contacts")){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),   
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        }else if(this.$route.path==="/organizationCard/"+this.$route.params.orgId){
            console.log('this.permissions.includes("can_delete_organizations")')
            console.log(this.permissions)
            if(!this.permissions.includes("can_delete_organizations")){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        }
        
    },
    organizationCard(id){
        if(id!==""){
            localStorage.contactId=id
            this.updateContactId(id)
            window.open('/organizationCard/'+id, '_blank');
        }
    },
    ...mapActions([
        'updateDealId',
        'updateContactId',
        'updateLoading'
    ]),
      changeHolder(event){
        if(this.field==='organization')
        {
            let obj=
            {
                cuid:{$oid:event.target.value}
            }
           this.organizationUpdate(obj)
        }
        else if(this.field==='contact')
        {
            let obj=
            {
                cuid:{$oid:event.target.value}
            }

            // console.log("event */*/*/*");
            // console.log(this.users);
            // for(let i in this.users){
            //     if(event.target.value===this.users[i]._id.$oid){
            //        this.ownerFullName
            //     }
            // }

           this.contactUpdate(obj)
        }
       
 
    },
     organizationUpdate(obj){
      let id=this.data._id.$oid
        axios({
          method:'POST',
          url:'/updateOrganization',
          baseURL: this.baseUrl,
          data: {
            objId:id,
            updateObj:obj
          },
          withCredentials:true
        }).then((res)=>{
            console.log(res);
            return res
        }).then((res)=>{
            if(res.data.status.code==0){
                //  this.organization=res.data.content.organization
                // if(res.data.content.deal.contactId!==undefined){
                //     this.contact=res.data.content.organization.contactId
                //     this.contactId=res.data.content.organization.contactId._id.$oid
                // }
                this.customFields=res.data.content.customFields
                this.isHiddenPhone=false
                this.isHiddenAddr=false
                this.selected=undefined
                this.$emit('updateOrganization')
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: this.$ml.get('COMPANY_UPDATED'),
                    text: res.data.status.desc 
                })
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
       contactUpdate(obj){
           let id=this.data._id.$oid
    //    let id=this.contactOrg._id.$oid
        axios({
          method:'POST',
          url:'/updateContact',
          baseURL: this.baseUrl,
          data: {
            objId:id,
            updateObj:obj
          },
          withCredentials:true
        }).then((res)=>{
            console.log(res);
            return res
        }).then((res)=>{
            if(res.data.status.code==0){
                this.customFields=res.data.content.customFields
                this.isHiddenPhone=false
                this.isHiddenAddr=false
                this.selected=undefined
                this.$emit('getContact')
                this.$notify({ 
                    group: 'foo',
                    type: 'success', 
                    title: this.$ml.get('CONTACT_UPDATED'),
                    text: res.data.status.desc 
                })
                 
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                 
            }
        })
    },
    filterName:function(value){
        value=String(value)
        if ( value.length > 50 ) {
            return value.substring(0,50) + '...'
        } else {
            return value
        }
    },
  },
  created(){

  },
    watch: {
        '$route': 'path'
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headerPanel{
    box-shadow: 0px 2px 2px #b0bac59e;
    min-height: 84px;
    border-radius: 4px;
}
.bg-organization{
    background: rgb(251,252,219);
    background: linear-gradient(90deg, rgba(222,246,250,1) 0%, rgba(251,252,219,1) 100%);
}
.bg-contact{
    background: rgb(251,252,219);
    background: linear-gradient(90deg, #EAE0F9 0%, #FBFCDB 100%);
}
.iptal:before{
    color:red
}
.btnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.btnStyle button.active {
  background-color: #66D0FF!important;
  border: 1px solid #66D0FF;
  color: white;
}
</style>
